<template>
  <div class="chat--button-wrapper" 
    :class="isCorrect ? `${type} correct` : type " 
    ref="element" 
    @click="(e) =>handleAction(e, text)"
    :data-name="text"
    
  >
    <div class="chat--button" :class="type" ref="element">
      <p v-html="text"></p>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';

import {gsap, Power2} from 'gsap'
export default {
  name: 'ChatButton',
  props: ['type', 'text', 'action','store', 'isCorrect'],
  methods: {
    transitionIn(){
      var buttonInnerText = this.$refs.element.querySelector('p');
      var TL = new gsap.timeline();
      gsap.set(this.$refs.element,{y: 50});
      gsap.set(buttonInnerText,{opacity: 0});

      TL
      .to(this.$refs.element, {opacity: 1, y: 0, duration: .15,ease:Power2.easeOut, 
        onStart: () =>{
          this.$store.dispatch('triggerScrollWindow', this.$refs.element.clientHeight);
        },
        onComplete: () =>{
          this.$refs.element.classList.add('showing')
        }
      })
      .to(buttonInnerText, 1,{opacity: 1})
    },
    handleAction(event,text){
      var app = document.getElementById('app');
      var minHeight = app.clientHeight;
      app.style.minHeight = `${minHeight}px`
      if(this.type === 'single' || this.type === 'single-answer'){
        this.$store.dispatch('triggerReply');
        this.$store.dispatch('isRightReply', true)
      }else if (this.type === 'double'){

        if(event.currentTarget.classList.contains('clicked')) return;
        let parent =  event.currentTarget.parentNode;
        let siblings = parent.querySelectorAll('.chat--button-wrapper.double')
        let isTrue = this.isCorrect;

        for(var i = 0; i < siblings.length; i++){
          siblings[i].classList.add('clicked');
          
          if(siblings[i].classList.contains('correct')){
            siblings[i].classList.add('right')
          }else{
            siblings[i].classList.add('uncorrect')
          }
          siblings[i].classList.add('clicked')
        }
        
        this.$store.dispatch('setSelectedAnswer', text)
        this.$store.dispatch('isRightReply', isTrue)
        setTimeout(() => this.$store.dispatch('triggerReply'), 1000)
        
      }else if (this.type === 'openOverlay'){
       
        this.$store.dispatch('openOverlay', this.action)
      }
      else if (this.type === 'openBadges'){
        this.$store.dispatch('openBadge', this.action)
        this.$store.dispatch('selectBadge', this.action)
      }
      
    }
  },
  mounted(){
   setTimeout(() => this.transitionIn(), 500)
  },
  computed:{
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss">
  .quiz-wrap{
    .chat--button-wrapper{
      animation: none;
    }
    .chat--button{
      background-color: #7E32B4;
      color:#fff;
      border-color: #fff;
    }
    .right{
      .chat--button{
        background-color: #50AF72;
        color: #fff;
        border-color: #fff;
      }
    }
    .uncorrect{
      .chat--button{
        background-color: #E25831;
        color: #fff;
        border-color: #fff;
      }
    }
  }
  .chat--button-wrapper{
    position: relative;
    overflow: hidden;
    max-width: 504px;
    opacity: 0;
    cursor: pointer;
    transition: opacity .5s ease-in-out;
    animation: buzz 3s infinite;
    &.showing{
      &:hover{
        opacity: .6 !important;
      }
    }
    
  }
  .chat--button{
    border-radius: 5px;
    border: 1px solid #2E70E2;
    background-color: #2E70E2;
    display: block;
    width: auto;
    padding: 32px 40px;
    margin-bottom: 8px;
    font-size: 18px;
    line-height: 24px;
    color: #fff;
    transition: background-color .5s ease-in-out;
    p{
      .emoji{
        font-size: 26px;
      }
    }
    &.single::after{
      content: '';
      position: absolute;
      bottom: 12px;
      right: 5px;
      background-image: url('../assets/reply-icon.svg');
      width: 18px;
      height: 18px;
      background-size: 18px 18px;
    }
    @media screen and (max-width: 767px) {
      padding: 24px 32px;
      p{
        .emoji{
          font-size: 18px;
        }
      }
    }
  }
  
  @keyframes buzz {
    0% {
      transform: translate3d(0, 0, 0) rotate(0deg);
    }
    3%{
      transform: translate3d(-1px, 0, 0) rotate(-5deg);
    }
    6% {
      transform: translate3d(2px, 0, 0) rotate(2deg);
    }
    9% {
      transform: translate3d(-2px, 0, 0) rotate(-2deg);
    }
    12% {
      transform: translate3d(1px, 0, 0) rotate(1deg);
    }
    15% {
      transform: translate3d(-1px, 0, 0) rotate(-5deg);
    }
    18% {
      transform: translate3d(2px, 0, 0) rotate(2deg);
    }
    21% {
      transform: translate3d(-2px, 0, 0) rotate(-2deg);
    }
    24% {
      transform: translate3d(1px, 0, 0) rotate(1deg);
    }
    27%{
      transform: translate3d(0, 0, 0) rotate(0deg);
    }
    100%{
      transform: translate3d(0, 0, 0) rotate(0deg);
    }
  }
</style>
